
import { Component, Vue } from "vue-property-decorator";
import { Spin } from "ant-design-vue";

import axios from "axios";
@Component
export default class Weapp extends Vue {
  data() {
    return {
      url: "",
      token: "",
      platform: "",
      spinning: true
    };
  }

  render() {
    return (
      <a-spin tip="程序加载中" spinning={this.spinning}>
        <div class="weapp">
          <iframe src={this.url} ref="frame"></iframe>
        </div>
      </a-spin>
    );
  }

  mounted() {
    this.$refs.frame.onload = () => {
      this.spinning = false;
    };
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const data = decodeURIComponent(window.location.hash)
      .substr(8)
      .split("weapp");
    console.log(data);
    this.url = data[2];
    this.platform = data[1];
    this.token = data[0];
    setInterval(() => {
      axios({
        method: "get",
        url: "/api/app/v1/identityAuthenticate/isIdentityAuthenticated",
        headers: {
          token: this.token
        }
      }).then(function(response) {
        if (response.data.body) {
          if (self.platform === "h5") {
            window.open("http://m.tydc.top/pages/user/index", "_self");
          } else {
            // eslint-disable-next-line no-undef
            wx.miniProgram.switchTab({
              url: "/pages/user/index"
            });
          }
        }
      });
    }, 400);
  }
}
